import { gql } from "@apollo/client";

export const GET_GAME_OF_THE_DAY = gql`
  query GameOfTheDay (
    $date: String!
  ) {
    gameOfTheDay(
      input: {
        date: $date, 
      }
    ) {
        date
        errors
        success
        classicTiles
        classicNumSolutions
        casualTiles
        casualNumSolutions
    }
  }
`;

export const GET_USER_GAME_PERCENTILE = gql`
  query UserGamePercentile(
    $userId: String!
    $date: String!
    $mode: String!
  ) {
    userGamePercentile(
      input: {
        userId: $userId
        date: $date
        mode: $mode
      }
    ) {
      success
      errors
      timePercentile
      completerCount
      showRank
    }
  }
`;

export const GET_RECENT_GAME_STATS = gql`
  query RecentGameStats (
    $days: Int
  ) {
    recentGameStats(
      input: {
        days: $days
      }
    ) {
      success
      errors
      games {
        date
        wins
        mode
        numSolutions
        tiles
      }
    }
  }
`;

export const GET_ADMIN_PULSE = gql`
  query AdminPulse {
    adminPulse(input: {}) {
      success
      errors
      classicTodayWins
      casualTodayWins
      classicYesterdayWins
      casualYesterdayWins
      dau
      newPlayersToday
    }
  }
`;

export const GET_ADMIN_ACTIVITY = gql`
  query AdminActivity {
    adminActivity(input: {}) {
      success
      errors
      dodRetentionPct
      activeStreakers
      activeUsers
      usersCompletedLast7Days
    }
  }
`;

export const GET_ADMIN_USER_GAME_SERIES = gql`
  query AdminUserGameSeries($days: Int) {
    adminUserGameSeries(input: { days: $days }) {
      success
      errors
      classic {
        date
        starts
        wins
        hint1Count
        hint2Count
        hint3Count
        medianElapsedTimeMs
      }
      casual {
        date
        starts
        wins
        hint1Count
        hint2Count
        hint3Count
        medianElapsedTimeMs
      }
    }
  }
`;

export const GET_ADMIN_TODAY_PUZZLE = gql`
  query AdminTodayPuzzle {
    adminTodayPuzzle(input: {}) {
      success
      errors
      classic {
        date
        starts
        wins
        completionRate
        medianElapsedTimeMs
        numSolutions
        hintBreakdown {
          zeroPct
          onePct
          twoPct
          threePct
        }
      }
      casual {
        date
        starts
        wins
        completionRate
        medianElapsedTimeMs
        numSolutions
        hintBreakdown {
          zeroPct
          onePct
          twoPct
          threePct
        }
      }
    }
  }
`;
